import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';
import { ZustellkennzeichenService } from '../../api';

export const getZustellkennzeichen =
  (mandantId: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new ZustellkennzeichenService()
      .getZustellkennzeichen(mandantId)
      .then(result => {
        dispatch({
          type: ActionTypes.GET_ZUSTELLKENNZEICHEN,
          payload: result.data,
        });
      });
  };
